import(/* webpackMode: "eager", webpackExports: ["DashboardLayout"] */ "/opt/buildhome/repo/apps/personal-web/components/dashboard-layout.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/personal-web/components/experience-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingFallback"] */ "/opt/buildhome/repo/apps/personal-web/components/ui/loading-fallback.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.3.1_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.3.1_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
